import { Directive } from '@angular/core';

@Directive({
	selector: '[appStatus]'
})
export class AppStatusDirective {
	constructor() {}
}
